import GroupPostComment from "../Entity/GroupPostComment";
import * as Yup from "yup";
import CrudApi from "@serie3/common/api/crudApi";
import MediaplannerGroupEndpoints from "../endpoints";
import listHandler from "@serie3/common/Domain/listHandler";

const createGroupPostCommentForm = (
  dataList,
  setDataFunction,
  groupId,
  postId,
  setEditingId
) => {
  const validationSchema = Yup.object({
    text: Yup.string().required("Required"),
  });

  
  const editFunction = async (values, originalValues) => {
    let payload = JSON.stringify(values, null, 2);
    const response = await CrudApi.edit(MediaplannerGroupEndpoints.endpoints.edit, payload);

    let originalPayload = JSON.stringify(originalValues, null, 2);
    listHandler.replaceItemInList(response.data, dataList, setDataFunction);
    setEditingId(0);
  };
  

  const onSubmit = async (values) => {
    values.group.id = groupId;
    values.share.id = postId;
    const originalValues = { ...values };
    if (values.id > 0) {
      editFunction(values, originalValues);
    } else {
      let payload = JSON.stringify(values, null, 2);
      const response = await CrudApi.createNew(
        MediaplannerGroupEndpoints.endpoints.comment,
        payload
      );

      if (response.ok) {
        listHandler.newToList(response, dataList, setDataFunction, null, true);
      }
    }
  };

  return {
    initialValues: GroupPostComment,
    onSubmit: async (values, { resetForm, setFieldValue, setSubmitting }) => {
      await onSubmit(values);
      await setFieldValue("text", "", false);
    },
  };
};

const setEditData = (editData) => {
  let GroupPostComment = {
    id: editData.id,
    text: editData.text,
    share: { id: editData.share.id },
    group: { id: editData.share.groupinfo.id },
  };

  return GroupPostComment;
};

export default { createGroupPostCommentForm, setEditData };
